import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hospital': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M128 244V204C128 197.4 133.4 192 140 192H180C186.6 192 192 197.4 192 204V244C192 250.6 186.6 256 180 256H140C133.4 256 128 250.6 128 244zM268 256H308C314.6 256 320 250.6 320 244V204C320 197.4 314.6 192 308 192H268C261.4 192 256 197.4 256 204V244C256 250.6 261.4 256 268 256zM192 340V300C192 293.4 186.6 288 180 288H140C133.4 288 128 293.4 128 300V340C128 346.6 133.4 352 140 352H180C186.6 352 192 346.6 192 340zM268 352H308C314.6 352 320 346.6 320 340V300C320 293.4 314.6 288 308 288H268C261.4 288 256 293.4 256 300V340C256 346.6 261.4 352 268 352zM448 476V512H0V476C0 469.4 5.4 464 12 464H31.5V85C31.5 73.4 42.2 64 55.5 64H144V24C144 10.7 154.7 0 168 0H280C293.3 0 304 10.7 304 24V64H392.5C405.8 64 416.5 73.4 416.5 85V464H436C442.6 464 448 469.4 448 476zM79.5 463H192V396C192 389.4 197.4 384 204 384H244C250.6 384 256 389.4 256 396V463H368.5V112H304V136C304 149.3 293.3 160 280 160H168C154.7 160 144 149.3 144 136V112H79.5V463zM266 64H240V38A6-6 0 0 1 234 32H214A6-6 0 0 1 208 38V64H182A6-6 0 0 1 176 70V90A6-6 0 0 1 182 96H208V122A6-6 0 0 1 214 128H234A6-6 0 0 1 240 122V96H266A6-6 0 0 1 272 90V70A6-6 0 0 1 266 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hospital.js
// module id = S5eH
// module chunks = 144